import { createTypes, createAction } from 'lib/action'
const LOAD_RENTAL_PRICE = createTypes('loadrentalprice','load')
const EXPORT_RENTAL_PRICE = createTypes('exportrentalprice','export')
const LOAD_RENTAL_PRICE_DETAIL = createTypes('loadrentalpricedetail', 'load')
const CREATE_RENTAL_PRICE = createTypes('createrentalprice', 'create')
const UPDATE_RENTAL_PRICE = createTypes('updaterentalprice', 'update')
const REMOVE_LISTS = `REMOVE_LISTS`

function removeLists() {
  return {
    type: REMOVE_LISTS,
  }
}

const loadRentalPrice = {
    request: (data, loading) =>
      createAction(LOAD_RENTAL_PRICE.REQUEST, { data, loading }),
    success: (lists, page, pageSize) =>
      createAction(LOAD_RENTAL_PRICE.SUCCESS, { lists, page, pageSize }),
    failure: () => createAction(LOAD_RENTAL_PRICE.FAITLURE),
}

const exportRentalPrice = {
  request: (data, loading) =>
    createAction(EXPORT_RENTAL_PRICE.REQUEST, { data, loading }),
  success: (lists, page) =>
    createAction(EXPORT_RENTAL_PRICE.SUCCESS, { lists }),
  failure: () => createAction(EXPORT_RENTAL_PRICE.FAITLURE),
}

const loadRentalPriceDetail = {
    request: (data, loading) =>
      createAction(LOAD_RENTAL_PRICE_DETAIL.REQUEST, { data, loading }),
    success: listDetail => createAction(LOAD_RENTAL_PRICE_DETAIL.SUCCESS, { listDetail }),
    failure: () => createAction(LOAD_RENTAL_PRICE_DETAIL.FAITLURE),
}

const createRentalPrice = {
    request: (data, loading) =>
      createAction(CREATE_RENTAL_PRICE.REQUEST, { data, loading }),
    success: res => createAction(CREATE_RENTAL_PRICE.SUCCESS, { res }),
    failure: () => createAction(CREATE_RENTAL_PRICE.FAITLURE),
}

const updateRentalPrice = {
    request: (data, loading) =>
      createAction(UPDATE_RENTAL_PRICE.REQUEST, { data, loading }),
    success: res => createAction(UPDATE_RENTAL_PRICE.SUCCESS, { res }),
    failure: () => createAction(UPDATE_RENTAL_PRICE.FAITLURE),
}
  
export {
    REMOVE_LISTS,
    removeLists,
    LOAD_RENTAL_PRICE,
    loadRentalPrice,
    CREATE_RENTAL_PRICE,
    createRentalPrice,
    UPDATE_RENTAL_PRICE,
    updateRentalPrice,
    LOAD_RENTAL_PRICE_DETAIL,
    loadRentalPriceDetail,
    EXPORT_RENTAL_PRICE,
    exportRentalPrice
}